
import axios from "axios";
import { Component, Vue } from "vue-property-decorator";
import SearchForm from "../../../components/SearchForm.vue";
import { KeywordVO, MstSearchVO } from "./vo/search.vo";

@Component({ components: { SearchForm } })
export default class Search extends Vue {
  //data
  recentSearchHistories: Array<MstSearchVO> = []; // 최근
  recentSearchHistoriesKey = false;

  placeholder = {} as KeywordVO;
  HotKeywords: Array<KeywordVO> = [];
  recommandKeywords: Array<KeywordVO> = [];

  isPopover = false;
  isClear = true;

  // 최근검색어 갱신
  onRecentSearchHistoryUpdated(): void {
    this.recentSearchHistories = SearchForm.getRecentSearchHistory();
  }

  // 검색 기록 삭제
  clearSearchHistory(): void {
    this.isPopover = false;
    SearchForm.clearSearchHistory();
    this.onRecentSearchHistoryUpdated();
  }

  activated(): void {
    this.onRecentSearchHistoryUpdated();
  }

  //initialized events
  created(): void {
    this.onRecentSearchHistoryUpdated();
    // 검색창, HOT, 추천 키워드
    axios.get(`/search/search-keywords`).then((r) => {
      this.placeholder = r.data.placeholder;
      this.HotKeywords = r.data.hotKeywords;
      this.recommandKeywords = r.data.recommandKeywords;
    });
  }
}
